import styled from 'styled-components';

export const FileViewerStyle = styled.div`
	display: flex;
	flex-direction: row;
`;

export const FileViewerFieldsStyle = styled.div`
	flex: 0 0 40%;
	padding-right: 1rem;
`;

export const FileViewerDocumentStyle = styled.div`
	overflow: auto;
	width: 100%;
`;
export const FileViewerDocumentInnerStyle = styled.div``;
